export default "__VITE_ASSET__BXIf_CnB__"